// reward link

export const GET_REWARD_LINK = 'GET_REWARD_LINK'

export const GET_REWARD_LINK_BALANCE = 'GET_REWARD_LINK_BALANCE'

export const GET_CURRENCY_CODE = 'GET_CURRENCY_CODE'

export const GET_REWARD_CUSTOMIZATION = 'GET_REWARD_CUSTOMIZATION'

export const GET_REWARD_CUSTOMIZATION_DETAILS =
  'GET_REWARD_CUSTOMIZATION_DETAILS'

export const GET_REWARD_ELEMENT_CUSTOMIZATION_BY_SELECTOR =
  'GET_REWARD_ELEMENT_CUSTOMIZATION_BY_SELECTOR'

export const GET_REWARD_CUSTOMIZATION_ETID = 'GET_REWARD_CUSTOMIZATION_ETID'

export const GET_REWARD_LINK_EMAIL = 'GET_REWARD_LINK_EMAIL'

export const GET_REWARD_LINK_FIRST_NAME = 'GET_REWARD_LINK_FIRST_NAME'

export const GET_REWARD_LINK_LAST_NAME = 'GET_REWARD_LINK_LAST_NAME'

export const REWARD_LINK_HAS_EXPIRATION_DATE = 'REWARD_LINK_HAS_EXPIRATION_DATE'

export const GET_REWARD_LINK_PLATFORM_IDENTITY_HASH =
  'GET_REWARD_LINK_PLATFORM_IDENTITY_HASH'

export const IS_PROMO_LINK = 'IS_PROMO_LINK'

export const TYPE_OF_REWARD_LINK = 'TYPE_OF_REWARD_LINK'

export const ORDER_TRACKING_PROPERTIES = 'ORDER_TRACKING_PROPERTIES'

export const GET_REWARD_LINK_UTID = 'GET_REWARD_LINK_UTID'

export const GET_REWARD_LINK_PARENT_REFERENCE_LINE_ITEM_ID =
  'GET_REWARD_LINK_PARENT_REFERENCE_LINE_ITEM_ID'

export const GET_IS_PRINTABLE_RL = 'GET_IS_PRINTABLE_RL'

export const GET_IS_EXPIRED = 'GET_IS_EXPIRED'

export const GET_IS_REDEEMED = 'GET_IS_REDEEMED'

export const GET_IS_LOCKED = 'GET_IS_LOCKED'

export const ORDER_INFO = 'ORDER_INFO'

export const GET_IS_DL_AND_DL_REDEMPTIONS_DISABLED = 'GET_IS_DL_AND_DL_REDEMPTIONS_DISABLED'

export const STATIC_REWARD_LINK_SERVICE = 'STATIC_REWARD_LINK_SERVICE'

// app

export const APP_GET_DISCLAIMERS = 'APP_GET_DISCLAIMERS'

// cart

export const GET_CART = 'GET_CART'

export const GET_CART_ITEMS = 'GET_CART_ITEMS'

export const GET_CART_EXTERNAL_REF_ID = 'GET_CART_EXTERNAL_REF_ID'

export const GET_CART_ITEM = 'GET_CART_ITEM'

export const GET_PHYSICAL_CART_ITEMS = 'GET_PHYSICAL_CART_ITEMS'

export const GET_ELECTRONIC_CART_ITEMS = 'GET_ELECTRONIC_CART_ITEMS'

export const GET_DIGITAL_CART_ITEMS_EXIST = 'GET_DIGITAL_CART_ITEMS_EXIST'

export const GET_CART_TOTAL = 'GET_CART_TOTAL'

export const GET_SHOW_CART = 'GET_SHOW_CART'

export const GET_PHYSICAL_CART_ITEMS_EXIST = 'GET_PHYSICAL_CART_ITEMS_EXIST'

export const GET_CART_ITEMS_FORMATTED_AS_PRODUCTS =
  'GET_CART_ITEMS_FORMATTED_AS_PRODUCTS'

// order

export const GET_BLACKLISTED_EMAIL_DOMAINS = 'GET_BLACKLISTED_EMAIL_DOMAINS'

export const GET_IS_PLACING_ORDER = 'GET_IS_PLACING_ORDER'

export const GET_ORDER_CONFIRMATION = 'GET_ORDER_CONFIRMATION'

// recipient data

export const GET_RECIPIENT_DATA = 'GET_RECIPIENT_DATA'

export const GET_PHYSICAL_RECIPIENT = 'GET_SHIPPING_ADDRESS'

export const GET_DIGITAL_RECIPIENT = 'GET_DIGITAL_RECIPIENT'

// catalog

export const GET_CATALOG = 'GET_CATALOG'

export const GET_CATALOG_SEARCH_PARAMS = 'GET_CATALOG_SEARCH_PARAMS'

export const GET_SEARCH_IS_VISIBLE = 'GET_SEARCH_IS_VISIBLE'

export const GET_CATALOG_BRANDS = 'GET_CATALOG_BRANDS'

export const GET_CATALOG_ITEMS = 'GET_CATALOG_ITEMS'

// analytics

export const GET_FLATTENED_CATALOG_ITEM_TYPES = 'GET_FLATTENED_CATALOG_ITEM_TYPES'

export const GET_LONGEST_SCROLL = 'GET_LONGEST_SCROLL'

// feedback

export const HAS_PARTICIPATED_IN_SURVEY = 'HAS_PARTICIPATED_IN_SURVEY'

// redemption history

export const GET_REDEMPTION_HISTORY = 'GET_REDEMPTION_HISTORY'

export const GET_NO_MORE_ITEMS = 'GET_NO_MORE_ITEMS'

// Individual RL recipient

export const GET_IS_FIRST_TIME_RECIPIENT = 'GET_IS_FIRST_TIME_RECIPIENT'

export const GET_RL_RECIPIENT_INFO = 'GET_RL_RECIPIENT_INFO'

// wallet

export const GET_IS_AUTHENTICATED = 'GET_IS_AUTHENTICATED'

export const GET_IS_SIGNUP_COMPLETE = 'GET_IS_SIGNUP_COMPLETE'

export const GET_RECIPIENT_DETAILS = 'GET_RECIPIENT_DETAILS'

// Direct Payments

export const GET_DIRECT_PAYMENT_AMOUNT = 'GET_DIRECT_PAYMENT_AMOUNT'

export const GET_DIRECT_PAYMENT_TYPE = 'GET_DIRECT_PAYMENT_TYPE'

export const GET_DIRECT_PAYMENT_SESSION_ID = 'GET_DIRECT_PAYMENT_SESSION_ID'

export const GET_DIRECT_PAYMENT_UTID = 'GET_DIRECT_PAYMENT_UTID'
